import Loading from "@/components/Loading/Loading"
import NoMessage from "@/components/noMessage/NoMessage"
import Pagination from "@/components/Pagination/Pagination"
import { useEnrolledByIdData } from "@/queries/queries"

import LecturesDetailsItem from "./LecturesDetailsItem"

export default function LecturesDetailsShow() {
  const enrolledRoundQuery = useEnrolledByIdData()

  if (enrolledRoundQuery.isLoading) return <Loading />
  if (!enrolledRoundQuery.data?.data) return <NoMessage name="Data" />

  const currentCourse = enrolledRoundQuery.data.data.course!
  const lectures =
    Object.values(enrolledRoundQuery.data.data?.lectures || {}).flat(1) || []

  return (
    <>
      <div className="d-flex flex-column gap-3">
        {lectures.map((ele) => {
          return (
            <LecturesDetailsItem
              key={ele.id}
              ele={ele}
              course={currentCourse}
              round={enrolledRoundQuery.data.data}
            />
          )
        })}
      </div>
      <Pagination
        pagination={enrolledRoundQuery.data.meta}
        route={`enrolled`}
      />
    </>
  )
}
